import { render, staticRenderFns } from "./PrevNextButtons.vue?vue&type=template&id=a02b17a6&scoped=true"
import script from "./PrevNextButtons.vue?vue&type=script&lang=js"
export * from "./PrevNextButtons.vue?vue&type=script&lang=js"
import style0 from "./PrevNextButtons.vue?vue&type=style&index=0&id=a02b17a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02b17a6",
  null
  
)

export default component.exports